'use client'

import { forwardRef } from 'react'
import {
  ArrowsIn as PhArrowsIn,
  CaretDoubleLeft as PhCaretDoubleLeft,
  CaretDoubleRight as PhCaretDoubleRight,
  CaretDown as PhCaretDown,
  CaretLeft as PhCaretLeft,
  CaretRight as PhCaretRight,
  CaretUp as PhCaretUp,
  CaretUpDown as PhCaretUpDown,
  Check as PhCheck,
  Checks as PhChecks,
  DotsSixVertical as PhDotsSixVertical,
  DotsThree as PhDotsThree,
  DotsThreeVertical as PhDotsThreeVertical,
  Minus as PhMinus,
  Plus as PhPlus,
  X as PhX,
} from '@phosphor-icons/react'
import type { Icon, IconProps } from '@phosphor-icons/react'

// Simple line glyphs that duotone (the app-wide weight) draws badly: carets
// fill their triangle and read as play buttons, and Check/X/Plus/Minus/dots
// sit on a 20% tinted box. These default to regular weight; `weight` still
// overrides. Import these from here, not from @phosphor-icons/react.
function regularWeight(PhIcon: Icon, name: string) {
  const Glyph = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
    <PhIcon ref={ref} weight="regular" {...props} />
  ))
  Glyph.displayName = name
  return Glyph
}

export const ArrowsIn = /* @__PURE__ */ regularWeight(PhArrowsIn, 'ArrowsIn')
export const CaretDoubleLeft = /* @__PURE__ */ regularWeight(PhCaretDoubleLeft, 'CaretDoubleLeft')
export const CaretDoubleRight = /* @__PURE__ */ regularWeight(PhCaretDoubleRight, 'CaretDoubleRight')
export const CaretDown = /* @__PURE__ */ regularWeight(PhCaretDown, 'CaretDown')
export const CaretLeft = /* @__PURE__ */ regularWeight(PhCaretLeft, 'CaretLeft')
export const CaretRight = /* @__PURE__ */ regularWeight(PhCaretRight, 'CaretRight')
export const CaretUp = /* @__PURE__ */ regularWeight(PhCaretUp, 'CaretUp')
export const CaretUpDown = /* @__PURE__ */ regularWeight(PhCaretUpDown, 'CaretUpDown')
export const Check = /* @__PURE__ */ regularWeight(PhCheck, 'Check')
export const Checks = /* @__PURE__ */ regularWeight(PhChecks, 'Checks')
export const DotsSixVertical = /* @__PURE__ */ regularWeight(PhDotsSixVertical, 'DotsSixVertical')
export const DotsThree = /* @__PURE__ */ regularWeight(PhDotsThree, 'DotsThree')
export const DotsThreeVertical = /* @__PURE__ */ regularWeight(PhDotsThreeVertical, 'DotsThreeVertical')
export const Minus = /* @__PURE__ */ regularWeight(PhMinus, 'Minus')
export const Plus = /* @__PURE__ */ regularWeight(PhPlus, 'Plus')
export const X = /* @__PURE__ */ regularWeight(PhX, 'X')
